export default "__VITE_ASSET__D599R_rp__"